import { DEFER_DEALER_SELECTION_KEY } from '../types/dealerConfig.types';
import type { DealerConfigSetting } from '../types/dealerConfig.types';
import { readBooleanSetting } from './readBooleanSetting';

/** Resolve the dealer's quote step-order flag from its raw config settings. */
export function resolveDeferDealerSelection(
    settings?: DealerConfigSetting[] | null,
): boolean {
    return readBooleanSetting(settings, DEFER_DEALER_SELECTION_KEY);
}
